<template>
	<el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form" label-width="0" status-icon>
		<el-form-item prop="mobile">
			<el-input
				v-model="loginForm.mobile"
				auto-complete="off"
				placeholder="请输入手机号码"
				prefix-icon="el-icon-mobile-phone"
				size="small"
				@keyup.enter.native="handleLogin"></el-input>
		</el-form-item>
		<el-form-item prop="code" style="position: relative">
			<el-input
				v-model="loginForm.code"
				auto-complete="off"
				placeholder="请输入验证码"
				prefix-icon="el-icon-message"
				size="small"
				@keyup.enter.native="handleLogin"></el-input>
			<el-button plain style="position: absolute; right: 0; bottom: 10px" type="primary" @click="handleSend">
				{{ msgText }}
			</el-button>
		</el-form-item>
		<el-form-item>
			<el-button
				:loading="isLoginIng"
				class="login-submit"
				size="small"
				style="margin-top: 50px"
				type="primary"
				@click.native.prevent="handleLogin">
				登录
			</el-button>
		</el-form-item>
	</el-form>
</template>

<script>
import {isvalidatemobile} from '@/util/validate'
import {mapGetters} from 'vuex'
import request from '@/router/axios'
import _ from 'lodash'

const MSGINIT = '发送验证码',
	MSGSCUCCESS = '${time}秒后重发',
	MSGTIME = 60

export default {
	name: 'Codelogin',
	data() {
		const validatePhone = (rule, value, callback) => {
			if (isvalidatemobile(value)[0]) {
				callback(new Error(isvalidatemobile(value)[1]))
			} else {
				callback()
			}
		}
		const validateCode = (rule, value, callback) => {
			if (value.length != 4) {
				callback(new Error('请输入4位数的验证码'))
			} else {
				callback()
			}
		}
		return {
			msgText: MSGINIT,
			msgTime: MSGTIME,
			msgKey: false,
			loginForm: {
				mobile: '',
				code: '',
			},
			loginRules: {
				mobile: [{required: true, trigger: 'blur', validator: validatePhone}],
				code: [{required: true, trigger: 'blur', validator: validateCode}],
			},
			isLoginIng: false,
		}
	},
	computed: {
		...mapGetters(['tagWel']),
	},
	created() {
		this.handleSend = _.throttle(this.handleSend, 5000)
	},
	methods: {
		//设置账号密码
		setLoginData(name, code) {
			Object.assign(this.loginForm, {mobile: name, code, isLocal: false})
			//直接登录
			this.handleLogin()
		},
		handleSend() {
			// 判断是否可以发送（时间限制）
			if (this.msgKey) {
				return
			}
			// 发送验证码
			this.$refs.loginForm.validateField('mobile', (valid) => {
				if (!valid) {
					request({
						url: '/admin/mobile/' + this.loginForm.mobile,
						method: 'get',
					}).then((response) => {
						if (response.data.data) {
							this.$message.success('验证码发送成功')
							this.timeCacl()
						} else {
							this.$message.error(response.data.msg)
						}
					})
				}
			})
		},
		handleLogin() {
			this.$refs.loginForm.validate(async (valid) => {
				if (valid) {
					this.isLoginIng = true
					//清理缓存
					try {
						await this.$store.dispatch('LogOut')
						await this.$store.dispatch('LoginByPhone', this.loginForm)
						setTimeout(() => {
							this.$router.push({path: this.tagWel.value})
							this.isLoginIng = false
						}, 600)
					} catch (e) {
						this.isLoginIng = false
					}
				}
			})
		},
		timeCacl() {
			// 计时避免重复发送
			this.msgText = MSGSCUCCESS.replace('${time}', this.msgTime)
			this.msgKey = true
			const time = setInterval(() => {
				this.msgTime--
				this.msgText = MSGSCUCCESS.replace('${time}', this.msgTime)
				if (this.msgTime === 0) {
					this.msgTime = MSGTIME
					this.msgText = MSGINIT
					this.msgKey = false
					clearInterval(time)
				}
			}, 1000)
		},
	},
}
</script>

<style>
.msg-text {
	display: block;
	width: 60px;
	font-size: 12px;
	text-align: center;
	cursor: pointer;
}

.msg-text.display {
	color: #ccc;
}

::v-deep .el-input__suffix {
	color: #409eff !important;
}

.send_code {
	cursor: pointer;
}

.send_code:hover {
	font-weight: bold;
}
</style>
